<template>
  <div id="content" class="main-content">
    <div class="layout-px-spacing">
      <div class="row layout-top-spacing">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 layout-spacing">
          <div class="widget widget-one">
            <div class="widget-heading">
              <h6 class>Statistics</h6>
            </div>
            <div class="w-chart">
              <div class="w-chart-section">
                <div class="w-detail">
                  <p class="w-title">Property Residents</p>
                  <p class="w-stats">{{userCount}}</p>
                </div>
              </div>

              <div class="w-chart-section">
                <div class="w-detail">
                  <p class="w-title">Property Managers</p>
                  <p class="w-stats">{{managersCount}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 layout-spacing widget-body">
          <div class="widget widget-card-four">
            <div class="widget-content">
              <div class="w-content">
                <div class="w-info w-chart">
                  <h6 class="value">{{userCount}}</h6>
                  <p class>All Users</p>
                </div>
                <div class>
                  <div class="w-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-home"
                    >
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                      <polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 layout-spacing">
          <div class="widget widget-activity-two">
            <div class="widget-heading">
              <h5 class>Pending Property Manager</h5>
            </div>

            <div class="widget-content">
              <div class="table-responsive">
                <table class="table table-bordered mb-4">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <!-- <th>Location</th> -->
                      <th>Phone Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(manager, i) in pendingPropertyManagers" :key="i">
                      <td>{{manager.fullName}}</td>
                      <!-- <td>Lagos</td> -->
                      <td>{{manager.phone}}</td>
                      <td>
                        <router-link :to="{name: 'view-user-profile', params: {userId: manager._id, type: userType.SUB_ADMIN} }" >View Profile</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="center-i" v-if="!pendingPropertyManagers.length">
                  <h3>No pending Property Manager</h3>
                </div>
              </div>

              <div class="tm-action-btn">
                <router-link :to="{name: 'property-manager'}" class="btn">View All</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "../Footer/index";
import {USER_TYPE} from '../../helpers/userType';

export default {
  data(){
    return {
      userType: USER_TYPE
    }
  },
  components: {
    Footer,
  },
  mounted(){
    this.$store.dispatch('GET_PROPERTY_MANAGERS');
    this.$store.dispatch('GET_PROPERTY_OWNERS');
    this.$store.dispatch('GET_TOTAL_USERS');
    this.$store.dispatch('GET_TOTAL_MANAGERS');
  },
  computed: {
    pendingPropertyManagers(){
      let managers = this.$store.getters.getPendingPropertyManager;
      return managers.length ? managers.slice(0,4) : [];
    },
    managersCount(){
      return this.$store.getters.getTotalManagerCount;
    },
    userCount(){
      return this.$store.getters.getTotalUserCount;
    },
  }
};
</script>

<style scoped>
.center-i {
    display: flex;
    justify-content: center;
}
</style>
